import dayjs from 'dayjs';
import { cachedStripHtml } from '../../../../../../validator/utils/cachedStripHtml.ts';
import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';

export interface IFormatValueByDatatypeOptions {
  /**
   * Se `true` le colonne RichText mantengono l'HTML originale invece di
   * essere appiattite a testo semplice (es. idratazione PDF, dove il
   * renderer interpreta l'HTML).
   */
  keepRichTextHtml?: boolean;
}

/**
 * Formatta un valore per la visualizzazione in base al tipo di dato della colonna.
 */
export function formatValueByDatatype(
  value: any,
  type: Datatype,
  options?: IFormatValueByDatatypeOptions,
): string {
  if (value == null || value === '') return '';

  switch (type) {
    case Datatype.Date: {
      const date = dayjs(value, 'YYYY-MM-DD', true);
      return date.isValid() ? date.format('DD/MM/YYYY') : String(value);
    }
    case Datatype.Boolean:
      return value === true || value === 'true' ? 'Sì' : 'No';
    case Datatype.Number:
      return String(value);
    case Datatype.RichText:
      if (options?.keepRichTextHtml) return String(value);
      // Strip DOM-free (string-strip-html): la label testuale funziona anche in
      // idratazione lato server (Node), dove DOMParser non esiste. Stesso strip
      // usato da tableUtils per ricerca/ordinamento → label e ricerca allineate.
      return cachedStripHtml(String(value));
    case Datatype.String:
    default:
      return String(value);
  }
}
